export const VETCOIN_ANIMATION_EVENT = "vetcoin:play-equipped-animation";
export const VETCOIN_ANIMATION_COMPLETE_EVENT = "vetcoin:animation-complete";
export const VETCOIN_BALANCE_TARGET_ID = "vetcoin-balance-target";

export type VetcoinAnimationDetail = {
  amount?: number;
};

export const triggerVetcoinAnimation = (detail?: VetcoinAnimationDetail) => {
  window.dispatchEvent(
    new CustomEvent(VETCOIN_ANIMATION_EVENT, { detail: detail || {} }),
  );
};

export const triggerVetcoinAnimationComplete = () => {
  window.dispatchEvent(new CustomEvent(VETCOIN_ANIMATION_COMPLETE_EVENT));
};
